var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('v-toolbar',{attrs:{"app":"","clipped-left":""}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_c('router-link',{attrs:{"to":"/logout"}},[_vm._v("Logout")])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }